import React from 'react';

import { Page } from '@tager/web-components';

import Layout from '@/layout';
import { convertAliasToPath } from '@/utils/common';
import { CustomApp_PageContext } from '@/typings/hocs';
import NotFoundPage from '@/pages/404';
import {
  fetchDealerReviewsThunk,
  fetchSingleDealerThunk,
} from '@/store/reducers/single-dealer';
import Dealer from '@/modules/Dealers/pages/Dealer';
import { fetchSeoTemplateThunk } from '@/store/reducers/seo-template';
import { useSingleDealerSeo } from '@/modules/Dealers/pages/Dealer/hooks';

type Props = { pageType: 'NOT_FOUND' | 'DEALERS_SINGLE_PAGE' };

function SingleDealer(props: Props) {
  const singleDealerSeo = useSingleDealerSeo();

  if (props.pageType === 'NOT_FOUND') {
    return <NotFoundPage />;
  }

  return (
    <Page {...singleDealerSeo}>
      <Layout>
        <Dealer />
      </Layout>
    </Page>
  );
}

SingleDealer.getInitialProps = async function ({
  query,
  store,
  res,
}: CustomApp_PageContext): Promise<Props> {
  const alias = convertAliasToPath(query.alias);

  try {
    const [dealer] = await Promise.all([
      store.dispatch(fetchSingleDealerThunk(alias)),
      store.dispatch(fetchSeoTemplateThunk('dealers_single')),
    ]);

    await store.dispatch(fetchDealerReviewsThunk(dealer.id));

    return {
      pageType: 'DEALERS_SINGLE_PAGE',
    };
  } catch (error: any) {
    if (error.status.code === 404) {
      if (res) {
        res.statusCode = 404;
      }

      return {
        pageType: 'NOT_FOUND',
      };
    }

    return {
      pageType: 'DEALERS_SINGLE_PAGE',
    };
  }
};

export default SingleDealer;
